import { AlertService } from '../../../../service/alert/alert.service';
import { Component, OnInit, Input, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms'

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateStructAdapter } from '@ng-bootstrap/ng-bootstrap/datepicker/adapters/ngb-date-adapter';

import Swal from 'sweetalert2';

import { AuthenticationService } from 'app/auth/service';
import { ActivityService } from 'app/service/activity/activity.service';
import { ParameterService } from 'app/service/parameter/parameter.service';
import { MaterialService } from 'app/service/material/material.service';
import { OperationService } from 'app/service/operation/operation.service';
import { ProofComponent } from '../../proof/proof.component';

@Component({
  selector: 'app-cash-payement',
  templateUrl: './cash-payement.component.html',
  styleUrls: ['./cash-payement.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CashPayementComponent implements OnInit {

  currentUser = Object.freeze(this.authenticationService.currentUserValue);
  @ViewChild(ProofComponent) child !: any;
  @Input() currentProject;
  @ViewChildren(ProofComponent)
  parseFloat = parseFloat

  public basicDPdata: NgbDateStructAdapter;

  proofExist = false

  public currentBudget

  public limitAmount = 0
  spendingMoneyPercentage = 0
  public amountLimitColor = ""

  public materialCategories
  public materials

  public createActivityForm: FormGroup;
  public activitySubmitted = false
  public loadingSubmitActivity = false

  public createMaterialForm: FormGroup;
  public materialSubmitted = false;
  public loadingSubmitMaterial = false

  public createPayementOperationForm: FormGroup;
  public payementOperationSubmitted = false
  public loadingSubmitCashPayement = false

  constructor(
    private authenticationService: AuthenticationService,
    private activityService: ActivityService,
    private parameterService: ParameterService,
    private materialService: MaterialService,
    private operationService: OperationService,
    private _formBuilder: FormBuilder,
    private modalService: NgbModal,
    private alertService: AlertService
  ) { }

  // convenience getter for easy access to activity form fields
  get a() {
    return this.createActivityForm.controls;
  }
  // convenience getter for easy access to material form fields
  get m() {
    return this.createMaterialForm.controls;
  }
  // convenience getter for easy access to payement operation form fields
  get p_o() {
    return this.createPayementOperationForm.controls;
  }

  getLimit(event) {
    this.limitAmount = 0
    let limit = parseFloat(this.p_o.line.value.cost_limit)
    let budgetCash = parseFloat(this.currentBudget.cash_amount)
    if (budgetCash <= limit) {
      this.limitAmount = parseFloat(this.currentBudget.cash_amount)
    } else {
      this.limitAmount = limit
    }
    let sum = 0
    for (let o = 0; o < event.operations.length; o++) {
      sum += parseFloat(event.operations[o].amount)
    }
    this.spendingMoneyPercentage = Math.round((sum / limit) * 100)
    return this.spendingMoneyPercentage
  }

  submitPayementOperation(res) {
    if (res.value == true) {
      this.loadingSubmitCashPayement = true
      let label = 'cash_payement'
      let cash_amount = this.currentBudget.cash_amount - this.p_o.amount.value
      this.operationService.cashPayement(this.currentUser.id, this.currentProject.review, this.p_o.budget.value, null, label, this.p_o.title.value, this.p_o.note.value, this.p_o.reference.value, this.p_o.activity.value, this.p_o.line.value.domain.id, this.p_o.material.value, this.p_o.line.value.id, this.p_o.operation_date.value, this.p_o.amount.value, cash_amount, this.currentBudget.bank_amount)
        .subscribe({
          next: (operation) => {
            this.child.submitProof(operation)
            this.loadingSubmitCashPayement = false
            this.payementOperationSubmitted = false
          },
          error: (e) => {
            this.loadingSubmitCashPayement = false
            this.payementOperationSubmitted = false
            console.error(e)
          }
        });
    }
  }

  confirmOperation() {
    this.payementOperationSubmitted = true
    if (this.createPayementOperationForm.invalid) {
      return
    } else {
      if (this.p_o.amount.value <= this.limitAmount) {
        if (this.proofExist) {
          console.log('yes')
          Swal.fire({
            title: 'Are you sure you want to go through this transaction ?',
            text: `${this.p_o.amount.value} DT, will be debited from your selected budget !`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#7367F0',
            cancelButtonColor: '#E42728',
            confirmButtonText: 'Yes, commit it!',
            customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-secondary ml-1'
            }
          }).then(res => this.submitPayementOperation(res));
        } else {
          this.alertService.errorAlert('You cant commit this yet', 'You have to import at least one justification file');
        }
      } else {
        this.alertService.errorAlert('This operation cannot be commited', 'The entered amount exceeds the given limits please try again');
      }
    }
  }

  handleProof(e) {
    if (!e) {
      this.proofExist = false
    } else {
      this.proofExist = true
    }
  }

  handleChosenBudget(budget) {
    this.limitAmount = null
    this.spendingMoneyPercentage = 0
    this.createPayementOperationForm.get('line').reset()
    this.currentBudget = budget
  }

  submitActivity() {
    this.activitySubmitted = true
    if (this.createActivityForm.invalid) {
      return
    } else {
      this.loadingSubmitActivity = true
      this.activityService.create(this.currentProject.id, this.a.title.value, this.a.description.value)
        .subscribe({
          next: (response) => {
            this.activitySubmitted = false
            this.loadingSubmitActivity = false
            this.modalService.dismissAll()
            this.createActivityForm.reset()
          },
          error: (e) => {
            this.loadingSubmitActivity = false
            this.activitySubmitted = false
            console.error(e)
          }
        });
    }
  }

  submitMaterial() {
    this.materialSubmitted = true
    if (this.createMaterialForm.invalid) {
      return
    } else {
      this.loadingSubmitMaterial = true
      this.materialService.create(this.currentUser.association_id, this.m.title.value, this.m.description.value, this.m.reference.value, this.m.material_date.value, this.m.category.value, this.m.cost.value)
        .subscribe({
          next: (response) => {
            this.loadingSubmitMaterial = false
            this.materialSubmitted = false
            this.modalService.dismissAll()
            this.createMaterialForm.reset()
          },
          error: (e) => {
            this.loadingSubmitMaterial = false
            this.materialSubmitted = false
            console.error(e)
          }
        });
    }
  }

  getMaterials(): void {
    this.materialService.getAll()
      .subscribe({
        next: (data) => {
          this.getMaterialCatgory()
          this.materials = data
        },
        error: (e) => console.error(e)
      });
  }

  getMaterialCatgory() {
    this.parameterService.getMaterialCategoryParameter()
      .subscribe({
        next: (response) => {
          this.materialCategories = response
        },
        error: (e) => console.error(e)
      });
  }

  ngOnInit(): void {
    this.currentBudget = this.currentProject.budgets[0]

    this.materialService.refreshMaterial.subscribe(() => {
      this.getMaterials();
    })
    this.getMaterials();

    //payement operation
    this.createPayementOperationForm = this._formBuilder.group({
      budget: ['', Validators.required],
      title: ['', Validators.required],
      note: [''],
      reference: ['', Validators.required],
      activity: ['', Validators.required],
      material: [''],
      line: ['', Validators.required],
      operation_date: [''],
      amount: ['', Validators.required],
    });

    //activity
    this.createActivityForm = this._formBuilder.group({
      title: ['', Validators.required],
      description: ['', Validators.required],
    });

    //material
    this.createMaterialForm = this._formBuilder.group({
      title: ['', Validators.required],
      description: ['', Validators.required],
      reference: ['', Validators.required],
      category: ['', Validators.required],
      material_date: ['', Validators.required],
      cost: ['', Validators.required],
    });
  }

  modalOpenForm(modal) {
    this.modalService.open(modal);
  }

}
